import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { RadioButton } from 'primereact/radiobutton'
import styled from 'styled-components'

/* ############### "GymFilteredList" Components ############### */

export const Divider = styled.div`
  border: 1px solid #cecece;
`
export const Line = styled.span`
  font-size: 1.3rem;
  color: #9d9d9d;

  @media (max-width: 1400px) {
    display: none;
  }
`
export const FormLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  //   justify-content: space-between;
  // flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
`
export const GymCardListContainer = styled.div`
  display: flex;
  max-height: 700px;
  overflow-y: auto;
  padding: 1rem 0.25rem 0.25rem;
  // justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: #d3d3d3 !important;
    border-radius: 10px;
  }

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px !important;
    background-color: #d3d3d3;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #7c7c7c;
    border-radius: 10px;
  }
`

/* ######### GYM list type Radio Buttons #########  */
export const GymListTypeWrapper = styled.div`
  display: flex;
  column-gap: 3rem;
  padding: 1rem 0.5rem 0;
`
export const GymListRadioWrapper = styled.div`
  display: flex;
  column-gap: 0.5rem;
  align-items: center;
`
export const StyledRadioLabel = styled.label<{ isSelected: boolean }>`
  color: ${({ isSelected }) => `${isSelected ? '#1388E5' : '#A8A8A8'}`};
  font-size: 16px;
  line-height: 17px;
  cursor: pointer;
  user-select: none;
`
export const StyledRadioButton = styled(RadioButton)`
  .p-radiobutton-box.p-highlight {
    border-color: #1388e5 !important;
  }

  .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    background: #fff !important;
  }

  .p-radiobutton-box {
    &:not(.p-disabled).p-focus {
      outline: 0 none;
      outline-offset: 0;
      box-shadow: 0 0 0 0.2rem rgba(26, 136, 238, 0.76);
      border-color: #1388e5;
    }
    &:not(.p-disabled) {
      &:not(.p-highlight) {
        &:hover {
          border-color: #1388e5;
        }
      }
      .p-radiobutton-icon {
        background-color: #1388e5 !important;
      }
    }

    .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
      border-color: #1388e5 !important;
      background: #1388e5 !important;
      color: #ffffff !important;
    }
  }
`

/* ############### "Search" Components ############### */

export const InputWrapper = styled.span`
  position: relative;
  display: inline-block;

  .input-icon {
    left: 0.5rem;
    color: #6c757d;
    position: absolute;
    top: 50%;
    margin-top: -10px;
  }
`
export const StyledInputText = styled(InputText)`
  width: 100%;
  min-width: 300px;
  border-radius: 10px;
  height: 50px;
  color: #363636;
  font-size: 14px;
  line-height: 16.71px;
  font-family: 'Inter', serif !important;
  font-weight: 500;
  padding-right: 16px;

  @media (max-width: 1200px) {
    min-width: 220px;
  }
`
/* ############### "GymFilterForm" Components ############### */

export const ResetButton = styled(Button)`
  width: 135px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;

  :disabled {
    opacity: 0.4;
  }
`
export const FilterButton = styled(Button)`
  width: 135px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
export const DropdownWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 35px;
  }

  .autocomplete-icon {
    position: absolute;
    left: 8px;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .selectedVal,
  .p-dropdown .p-dropdown-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selectedVal {
    margin-top: 0.5rem;
    font-weight: 700;
  }

  .p-dropdown .p-dropdown-label {
    padding-left: 2rem;
    padding-right: 0;
  }
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  width: 400px;
  height: 50px;
  border-radius: 10px;
  align-items: center;

  .p-dropdown-panel {
    z-index: 1004 !important;
    position: absolute !important;
    left: 0px !important;
    top: 52px !important;
    min-width: 100% !important;
    min-height: 100% !important;
    background: #ffffff !important;
    transform-origin: center top !important;
  }

  .p-dropdown-items-wrapper {
    max-height: 250px !important;
  }

  @media (max-width: 1200px) {
    width: 16rem;
  }
`
export const DatePickerWrapper = styled.div`
  width: 160px;
`
/* ############### Gym Card(Personal, Group, Trainer) Components ############### */

export const StyledCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 300px;
  max-width: 300px;
  height: 330px;
  padding: 0 0 1rem;
  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 8px;
`
export const CardHeaderOverlay = styled.div`
  position: relative;
  width: 300px;
  max-width: 300px;
  height: ${({ hasPhoto }: { hasPhoto?: boolean }) => `${hasPhoto ? '50px' : '20px'}`};
  min-height: ${({ hasPhoto }: { hasPhoto?: boolean }) => `${hasPhoto ? '48px' : '20px'}`};
  // min-height: 48px;
  background: #ffdce8;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: ${({ hasPhoto }: { hasPhoto?: boolean }) => `${hasPhoto ? '34px' : '8px'}`};
`
export const FavoriteContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 12px;
`

export const GymSalonName = styled.span`
  color: #354147;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  height: 33px;
  color: #354147;
  margin-bottom: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
export const SalonCapacity = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  margin-top: 6px;

  span {
    font-size: 14px;
    font-weight: 600;
  }
`
export const SalonLocation = styled.span`
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
export const Summary = styled.div`
  margin: 8px 0;
  height: 80px;
  max-height: 80px;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #646464;
  text-align: center;

  p {
    margin: 0 0 3px;
    padding: 0;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;

  // display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`
export const TrainerSummary = styled.div`
  margin: 8px 0 0;
  max-height: 72px;
  font-weight: 400;
  font-size: 12px;
  color: #646464;
  text-align: center;
  span {
    line-height: 12px !important;
  }
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  flex-grow: 1;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const GroupTrainerArea = styled.div`
  margin-top: 6px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const TrainerInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.5rem;

  img {
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }

  .gym-trainer-name {
    font-size: 14px;
    line-height: 17px;
    font-weight: 700;
  }
  .gym-trainer-info {
    font-size: 12px;
  }
`
export const LessonDate = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.5rem;
  margin-top: 16px;

  span {
    font-size: 12px;
  }
`
export const WorkingHours = styled.div`
  margin: 6px 0;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #354147;

  span.wh-title {
    font-weight: 700;
  }
`
export const ReservationButton = styled(Button)`
  width: 230px;
  height: 45px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
/* ########### Reservation Sidebar Components ################# */

/* Reservation Scheduler Modal Components */
export const ActionArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -4px;
  margin-top: 20px;
  border-bottom-right-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
`
export const CancelButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;

  :disabled {
    opacity: 0.4;
  }
`
export const ConfirmButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`

/* ########### Schedule Sidebar Components ############ */
export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
export const ContentArea = styled.div`
  flex-grow: 1;
`
export const SidebarActionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 1rem 0 0.5rem;
`
export const Header = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 1rem;
`
export const ReservationSummary = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #222e47;
`
export const ImagePreview = styled.div`
  background: ${(props: { url: string }) => `url(${props.url})`};
  width: 150px;
  height: 150px;
  margin: 10px 0;
`
export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .reservation-subtitle {
    font-size: 1rem !important;
    font-weight: 700;
    line-height: 19px;
  }
`
export const InfoListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 17px;

  img {
    width: 20px;
    height: 20px;
  }

  .reservation-info-title {
    font-weight: 700;
    white-space: nowrap;
  }

  .reservation-info-value {
    word-break: break-words;
    word-wrap: break-word;
  }
`
export const SidebarCancelButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
`
export const SidebarConfirmButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  justify-content: center;
`
